<template>
    <div>
        <el-table :data="compare" key="update" border style="width:97%">
            <el-table-column :label="title" prop="name"></el-table-column>
            <el-table-column label="修订后" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
            <el-table-column label="修改前" prop="before">
                <template slot-scope="scope">
                    <span v-html="scope.row.before"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "update_pay",
        props: {
            order_edit: {
                required: true
            }
        },
        data() {
            return {
                title:'',
                compare: []
            }
        },
        created() {
            this.title = '修订项(回款ID:'+this.order_edit.content.id+')';
            this.setTitle();
        },
        methods:{
            addColor(Object){
                if(Object.before !== Object.after){
                    Object.after = "<span style='color: red'>"+Object.after+"</span>";
                }
                return Object;
            },
            setTitle(){
                let play_pay={
                    name: '计划回款金额',
                    before:this.order_edit.before_content.plan_amount,
                    after: this.order_edit.content.plan_amount
                };
                let play_at={
                    name: '计划回款日期',
                    before: this.order_edit.before_content.plan_at,
                    after: this.order_edit.content.plan_at
                };

                let  actual_pay= {
                    name: '实际回款金额',
                    before:this.order_edit.before_content.actual_amount,
                    after: this.order_edit.content.actual_amount
                };
                let  actual_at= {
                    name: '实际回款日期',
                    before: this.order_edit.before_content.actual_at,
                    after: this.order_edit.content.actual_at
                };
                this.compare.push(this.addColor(play_pay));
                this.compare.push(this.addColor(play_at));
                this.compare.push(this.addColor(actual_pay));
                this.compare.push(this.addColor(actual_at));

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/update_pay.vue